import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { Button } from '#components/button/button.tsx';
import { Spinner } from '#components/spinner/spinner.tsx';
import { cn } from '#lib/utils.ts';

export type IconButtonProps = ComponentProps<'button'> &
  Omit<VariantProps<typeof Button>, 'size'> & {
    size?: 'xs' | 'sm' | 'default';
    variant?: 'default' | 'destructive' | 'secondary' | 'ghost';
  };

function IconButton({
  className,
  size = 'default',
  isLoading = false,
  disabled = false,
  children,
  ...props
}: IconButtonProps) {
  const sizeClasses = {
    xs: 'size-6',
    sm: 'size-8',
    default: 'size-10',
  };

  return (
    <Button
      disabled={disabled || isLoading}
      className={cn(
        sizeClasses[size],
        className,
        isLoading && '[&>svg:not(:first-of-type)]:hidden',
        !isLoading && '[&>svg:first-of-type]:hidden',
      )}
      {...props}
    >
      <Spinner className="text-current" />
      {children}
    </Button>
  );
}

export default IconButton;

export { IconButton };
